import { MarkerSugarer } from "./MarkerSugarer.js";
import { TreeParameterSugarer } from "./TreeParameterSugarer.js";
import { assertNever } from "../../utils/assertNever.js";
var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
class ErrorLocator {
  static locateMarkerPath(path) {
    return path.map((marker) => MarkerSugarer.sugarMarker(marker)).join(this.GLUE);
  }
  static locateInternalState(state) {
    function stateToPath(state2) {
      if (state2 === void 0) {
        return [];
      }
      switch (state2.type) {
        case "field":
          return [...stateToPath(state2.parent), TreeParameterSugarer.sugarField(state2.fieldMarker.fieldName)];
        case "entityRealm": {
          const blueprint = state2.blueprint;
          if (blueprint.type === "subTree") {
            return [
              TreeParameterSugarer.sugarRootEntity(
                state2.entity.entityName,
                blueprint.marker.parameters.isCreating ? void 0 : blueprint.marker.parameters.where
              )
            ];
          }
          if (blueprint.type === "listEntity") {
            return [...stateToPath(blueprint.parent)];
          }
          if (blueprint.type === "hasOne") {
            return [...stateToPath(blueprint.parent), MarkerSugarer.sugarHasOneRelationMarker(blueprint.marker)];
          }
          return assertNever();
        }
        case "entityList": {
          const blueprint = state2.blueprint;
          if (blueprint.parent === void 0) {
            return [
              TreeParameterSugarer.sugarRootEntityList(
                state2.entityName,
                blueprint.marker.parameters.isCreating ? void 0 : blueprint.marker.parameters.filter
              )
            ];
          }
          const hasMany = blueprint.marker;
          return [...stateToPath(blueprint.parent), MarkerSugarer.sugarHasManyRelationMarker(hasMany)];
        }
      }
    }
    return stateToPath(state).join(this.GLUE);
  }
}
__publicField(ErrorLocator, "GLUE", ".");
export {
  ErrorLocator
};
//# sourceMappingURL=ErrorLocator.js.map
